// Compact by design: six of these sit in a single row above the filters, so
// the block competes directly with the operations list for vertical space
// (~50px -> ~38px). Wording and content are unchanged.
.root {
  display: flex;
  align-items: center;
  gap: 8px;
  flex: 1 1 0;
  min-width: 140px;
  padding: 6px 10px;
  border: 1px solid var(--color-border);
  border-radius: 8px;
  background: var(--color-background);
  cursor: pointer;
  text-align: left;
  transition:
    border-color 0.12s,
    box-shadow 0.12s,
    background 0.12s;
}

.root:hover {
  border-color: var(--color-border-strong);
}

// Selected = accent tint + 2px accent ring (design: stroke width 2). Ring via
// inset shadow so the 2px does not shift the row layout.
.root-is-active {
  border-color: var(--color-accent-foreground);
  background: var(--color-accent);
  box-shadow: inset 0 0 0 1px var(--color-accent-foreground);
}

.dot {
  width: 9px;
  height: 9px;
  border-radius: 50%;
  flex: none;
}

.count {
  font-size: 17px;
  font-weight: 700;
  line-height: 1;
  color: var(--color-foreground);
}

.text {
  display: flex;
  flex-direction: column;
  gap: 1px;
  min-width: 0;
}

.label {
  font-size: 11.5px;
  font-weight: 600;
  line-height: 1.15;
  color: var(--color-foreground);
}

.sub {
  font-size: 10px;
  font-weight: 500;
  line-height: 1.15;
  color: var(--color-muted-fg);
}

.sub-is-aging {
  color: var(--color-warning-foreground);
}

.info-icon {
  width: 13px;
  height: 13px;
  flex: none;
  margin-left: auto;
  color: var(--color-muted-fg);
}

// The resolved operations.list query shown under the tooltip's description
// (XT-341) — monospace so it reads as data, not prose.
.tooltip-query {
  margin-top: 4px;
  font-family: var(--font-mono, ui-monospace, monospace);
  font-size: 10.5px;
  opacity: 0.8;
}
